import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const ventajonTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.ventajon,
  logoUrl: "https://cdn.nemuru.com/assets/logos/ventajon-logo.png",
  palette: {
    primary: {
      main: "#cf3339",
      contrastText: "#fff",
    },
    secondary: {
      main: "#113f96",
      contrastText: "#fff",
    },
    warning: {
      main: "#ffc61d",
      contrastText: "#ffffff",
      light: "rgba(255, 202, 40, 0.15)",
    },
    info: {
      main: "#139cd2",
      contrastText: "#ffffff",
      light: "rgba(130,199,221,0.3)",
    },
    success: {
      main: "#268750",
      contrastText: "#ffffff",
      light: "#8ace8f",
    },
    error: {
      main: "#cf3339",
      contrastText: "#ffffff",
      light: "rgba(239,87,87,0.15)",
    },
    text: {
      title: "#113f96",
      primary: "#333333",
      secondary: "#5a5a57",
    },
    // additional colors
    dark: {
      main: "#efefef",
      accent: "#cf3339",
      contrastText: "#113f96",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#8ace8f",
      approved: "#007b79",
      analysing: "#afcff8",
      sent: "#113f96",
      cancelled: "#d8d8d8",
      denied: "#cf3339",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  typography: {
    fontFamily: "Arial, sans-serif",
  },
  background: "#fff",
  customBorderRadius: {
    button: 5,
    paper: 10,
    chip: 6,
  },
};
